import { SIZE_33 } from '@/lib/gridElements/size';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';

//kpis
import { totalEngagementConfig } from '@/lib/analytics/kpis/twitter/totalEngagement';
import { avgEngagementRatePerTweetConfig } from '@/lib/analytics/kpis/twitter/avgEngagementRatePerTweet';
import { avgEngagementOnImpressionsPerTweetConfig } from '@/lib/analytics/kpis/twitter/avgEngagementOnImpressionsPerTweet';
import { likesReceivedConfig } from '@/lib/analytics/kpis/twitter/likesReceived';
import { avgLikesReceivedConfig } from '@/lib/analytics/kpis/twitter/avgLikesReceived';
import { retweetsConfig } from '@/lib/analytics/kpis/twitter/retweets';
import { avgRetweetsConfig } from '@/lib/analytics/kpis/twitter/avgRetweets';
import { totalRepliesReceivedConfig } from '@/lib/analytics/kpis/twitter/totalRepliesReceived';
import { avgRepliesReceivedConfig } from '@/lib/analytics/kpis/twitter/avgRepliesReceived';
import { totalViewsConfig } from '@/lib/analytics/kpis/twitter/totalViews';
import { avgViewsPerVideoConfig } from '@/lib/analytics/kpis/twitter/avgViewsPerVideo';

//charts
import { likesHistoryConfig } from '@/lib/analytics/charts/twitter/likesHistory';
import { retweetsHistoryConfig } from '@/lib/analytics/charts/twitter/retweetsHistory';
import { bestTimeToPostConfig } from '@/lib/analytics/charts/twitter/bestTimeToPost';
import { avgEngagementPerTweetTypeConfig } from '@/lib/analytics/charts/twitter/avgEngagementPerTweetType';
import { avgEngagementRateHistoryConfig } from '@/lib/analytics/charts/twitter/avgEngagementRateHistory';
import { repliesHistoryConfig } from '@/lib/analytics/charts/twitter/repliesHistory';
import { videoViewsHistoryConfig } from '@/lib/analytics/charts/twitter/videoViewsHistory';

//widget
import { mostEngagingTweetsConfig } from '@/lib/analytics/widget/twitter/mostEngagingTweetsConfig';

export const EngagementTwitter = [
    { ...totalEngagementConfig, size: SIZE_33 },
    { ...avgEngagementRatePerTweetConfig, size: SIZE_33 },
    { ...avgEngagementOnImpressionsPerTweetConfig, size: SIZE_33 },
    mostEngagingTweetsConfig,
    likesReceivedConfig,
    avgLikesReceivedConfig,
    retweetsConfig,
    avgRetweetsConfig,
    likesHistoryConfig,
    retweetsHistoryConfig,
    bestTimeToPostConfig,
    avgEngagementPerTweetTypeConfig,
    avgEngagementRateHistoryConfig,
    { ...totalRepliesReceivedConfig, orientation: ORIENTATION_VERTICAL },
    { ...avgRepliesReceivedConfig, orientation: ORIENTATION_VERTICAL },
    totalViewsConfig,
    avgViewsPerVideoConfig,
    repliesHistoryConfig,
    videoViewsHistoryConfig
];

export const requestTwitterParams = [
    // TwitterMedia
    [
        'engagement',
        'average_engagement_rate_per_tweet',
        'average_engagement_on_impressions_per_tweet',
        'likes',
        'average_likes',
        'retweets',
        'average_retweets_per_tweet',
        'likes_history'
    ],
    [
        'retweets_history',
        'best_time_to_post',
        'average_engagement_per_tweet_type',
        'average_engagement_rate_history',
        'replies',
        'average_replies_per_tweet',
        'videos_views',
        'average_views_per_video',
        'replies_history',
        'video_views_history'
    ]
];
